import { useEffect, useState } from 'react';
import clsx from 'clsx';

import Modal from '../Modal';
import { IProps } from '../../interfaces/components/confirmationModal.interface';

const ConfirmationModal = ({
  open,
  closeModal,
  heading,
  body,
  actionButtons,
  actionMap,
}: IProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [showModalContent, setShowModalContent] = useState(false);

  useEffect(() => {
    if (open) {
      setModalOpen(true);
      setTimeout(() => {
        setShowModalContent(true);
      }, 10);
    } else {
      setShowModalContent(false);
      setTimeout(() => {
        setModalOpen(false);
      // waits until modal slides out of view
      }, 100);
    }
  }, [open]);

  return modalOpen ? (
    <Modal className="confirm" closeModal={closeModal} showModalContent={showModalContent}>
      <h1>{heading}</h1>
      {body.map((b) => (
        <p className={b.className} key={b.text}>{b.text}</p>
      ))}
      {actionButtons.map((button) => (
        <button
          id={button.elementAttributes.id}
          // eslint-disable-next-line react/button-has-type
          type={button.elementAttributes.type}
          className={clsx('button', button.additionalClassNames)}
          onClick={actionMap[button.action]}
        >
          {button.text}
        </button>
      ))}
    </Modal>
  ) : null;
};

export default ConfirmationModal;
